import { Image } from 'foundations-components/transitional/components/Image';
import imageUrls from '../images/imageUrls';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const getEngageAILogoConfig = isMobile => {
  const url = isMobile ? imageUrls.engageAIMobileLogo : imageUrls.engageAILogo;
  return {
    url,
    altText: 'Engage.AI'
  };
};
export const EngageAILogo = () => {
  const {
    isMobile
  } = useResponsiveness();
  const {
    url,
    altText
  } = getEngageAILogoConfig(isMobile);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Image, {
      alt: altText,
      responsive: false,
      src: url
    })
  });
};